import {
  ICravingInfo,
  IDiarySummary,
  ISmokingDiary,
  ISmokingDiaryMonthlyRecord,
  ITodayDiaryStatus,
} from 'src/@types/apiResponse';

import { TApiResponseData } from '../apiTypes';
import instance from '../axios';

/** 월별 금연/갈망일지 작성여부 조회 */
export const getSmokingDiaryMonthlyRecord = async (date: string) => {
  try {
    const url = `/smokingDiary/monthly/record/${date}`;

    const response = await instance.get<TApiResponseData<ISmokingDiaryMonthlyRecord[]>>(url);
    return response.data;
  } catch (error) {
    // Error handling delegated to Axios interceptor
  }
};

/** 일별 금연/갈망일지 요약 조회 */
export const getSmokingDiaryWithCraving = async (date: string) => {
  try {
    const url = `/smokingDiary/withCraving/${date}`;

    const response = await instance.get<TApiResponseData<IDiarySummary>>(url);
    return response.data;
  } catch (error) {
    // Error handling delegated to Axios interceptor
  }
};

/** 금연일지 조회 */
export const getSmokingDiary = async (date: string) => {
  try {
    const url = `/smokingDiary/${date}`;

    const response = await instance.get<TApiResponseData<ISmokingDiary>>(url);
    return response.data;
  } catch (error) {
    // Error handling delegated to Axios interceptor
  }
};

/**
 * 금연일지 작성
 * SPEC-DIARY-CAUSE-001: cravingCauseList 는 서버로 전송 시 `{cdId, cdPid}` 를
 * 숫자 코드로 직렬화한다 (Jackson 이 numeric code 또는 enum name string 을 수락).
 */
export type ISmokingDiaryRequestCause = {
  cdId: number;
  cdPid: number;
  etcContent?: string;
};

export type ISmokingDiaryRequest = Omit<ISmokingDiary, 'cravingCauseList'> & {
  cravingCauseList?: ISmokingDiaryRequestCause[];
};

export const setSmokingDiary = async (quitSmokingData: ISmokingDiaryRequest) => {
  try {
    const url = `/smokingDiary`;

    const response = await instance.post<TApiResponseData<null>>(url, quitSmokingData);
    return response.data;
  } catch (error) {
    // Error handling delegated to Axios interceptor
  }
};

/** 일별 갈망 이력/통계 조회 */
export const getUserCravingInfo = async (date: string) => {
  try {
    const url = `/userCraving/info/${date}`;

    const response = await instance.get<TApiResponseData<ICravingInfo>>(url);
    return response.data;
  } catch (error) {
    // Error handling delegated to Axios interceptor
  }
};

/** 오늘 금연일지 상태 조회 */
export const getTodayDiaryStatus = async () => {
  try {
    const url = `/smokingDiary/today/status`;

    const response = await instance.get<TApiResponseData<ITodayDiaryStatus>>(url);
    return response.data;
  } catch (error) {
    // Error handling delegated to Axios interceptor
  }
};
